export default {"src":"/_next/static/media/visa.2f6b693f.svg","height":17,"width":51,"blurWidth":0,"blurHeight":0};